import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from "rxjs";
import { UserRol } from "./api-interfaces/userrol.interface";
import { chiefWorkshop } from "./api-interfaces/chiefWorkshop";
import { HelperService } from "../helperService";

@Injectable({
    providedIn: 'root'
})
export class APIchiefWorkshopService {
    ApiURL: string = "";
    constructor(private http: HttpClient, private helperService: HelperService) {
        this.ApiURL = environment.ServicerChiefUrl + 'ChiefofWorkshop/';
    }

    public get(countryId:string): Observable<chiefWorkshop[]>{
        const headers = new HttpHeaders().set('Authorization', `Bearer ${this.helperService.TokenBooking}`);
        const requestOptions = {
            headers: headers,
        };
          return this.http.get<chiefWorkshop[]>(this.ApiURL + encodeURIComponent(countryId),requestOptions);
        
     
    }

    public post(data): Observable<any> {
        const headers = new HttpHeaders().set('Authorization', `Bearer ${this.helperService.TokenBooking}`);
        const requestOptions = {
            headers: headers,
        };
        return this.http.post<any>(this.ApiURL, data,requestOptions)
  }

  public put(data):Observable<any> {
    const headers = new HttpHeaders().set('Authorization', `Bearer ${this.helperService.TokenBooking}`);
    const requestOptions = {
        headers: headers,
    };
    return this.http.put<any>(this.ApiURL,data,requestOptions) //include id
    }

    public delete(id: number):  Observable<any>{
        const headers = new HttpHeaders().set('Authorization', `Bearer ${this.helperService.TokenBooking}`);
        const requestOptions = {
            headers: headers,
        };
        let apiURL = `${this.ApiURL}${id}`;
        return this.http.delete(apiURL,requestOptions)
    }

}